export const REPORT_TYPE_IDS = {
  crm: "1",
  internal: "2",
} as const;
